import React from 'react';
import Helmet from 'react-helmet';

const Test = () => (
    <div>
        <Helmet
            title="Test | WatchESPN"
            meta={[
                { name: 'robots', content: 'noindex, nofollow' }
            ]}
        />
        <h1>Hello</h1>
    </div>
);

export default Test;



// WEBPACK FOOTER //
// ./app/page/Test.js